import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import { UserForGridModel } from '../../../models/user/userForGridModel';
import { DropdownModel } from "../../../models/dropdownModel";
import { enumToDropdownArray } from '../../../common/functions/helperFunctions';
import { RelationType, UserType } from "../../../common/enums";
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import FormControl from '@material-ui/core/FormControl';
import * as Constants from '../../../common/constants';
import Paginator from '../../../common/components/paginator/paginator';
import Growl from '../../../common/components/alertMessage/growl';
import Radio from '@material-ui/core/Radio';
import UserService from '../../../services/userService';
import { UserGridModel } from "../../../models/user";

interface IProps {
    saveClick: any,
    cancelClick: any,
    isVisible: boolean,
    selectedUser: UserForGridModel,
    dialogHeader: string,
    saveCaretakerClick: any
}

interface IState {
    currentUser: UserForGridModel;
    isLoading: boolean;
    validationMessage: string;
    relationType: Array<DropdownModel>;
    userTypes: Array<DropdownModel>;
    searchText: string;
    users: Array<UserForGridModel>;
    selectedUser: UserForGridModel;
    page: number;
    numberOfPages: number;
    from: number;
    numberOfRows: number;
    totalRecordsCount: number;
}

class UserFamilyAddEditDialog extends React.Component<IProps, IState> {
    growl: any;
    initFrom = 0;
    numberOfRows = 10;
    userService = new UserService();

    constructor(props: IProps) {
        super(props);

        if (!props.selectedUser) {
            props.selectedUser = new UserForGridModel();
        }

        this.state = {
            currentUser: props.selectedUser,
            isLoading: false,
            validationMessage: '',
            relationType: new Array<DropdownModel>(0),
            userTypes: new Array<DropdownModel>(0),
            searchText: '',
            users: new Array<UserForGridModel>(0),
            selectedUser: new UserForGridModel(),
            page: 1,
            from: this.initFrom,
            numberOfPages: 1,
            numberOfRows: this.numberOfRows,
            totalRecordsCount: 0
        };
    }

    componentDidMount() {
        const relationType: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];
        const userTypes: Array<DropdownModel> = enumToDropdownArray(UserType, true);
        const user = { ...this.state.currentUser }
        user.userTypeId = 1;
        this.setState({ relationType: relationType.concat(enumToDropdownArray(RelationType, true)), userTypes: userTypes, currentUser: { ...user } });
    }

    handleSaveButton = (event, close) => {
        event.preventDefault();
        const user = this.state.currentUser;
        this.props.saveClick(user, close);
    }

    handleCaretakerSaveButton = (event, close) => {
        event.preventDefault();
        const user = { ...this.state.selectedUser };
        user.relationType = this.state.currentUser.relationType;
        this.props.saveCaretakerClick(user, close);
    }

    handleCancelButton = () => {
        this.props.cancelClick();
    }

    handleChange = (key, value) => {
        const user: UserForGridModel = { ...this.state.currentUser };
        user[key] = value;
        this.setState({ currentUser: { ...user } });
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchButtonClick();
        }
    }

    handleSearchButtonClick = () => {
        if (!this.state.searchText || this.state.searchText.trim() == '') {
            return;
        }
        this.setState({
            isLoading: true,
            page: 1
        },
            () => this.getAllFilteredItems(this.state.page, this.state.numberOfRows)
        );
    }

    getAllFilteredItems(page: number, numberOfRows: number) {
        let from = (page - 1) * this.state.numberOfRows;

        this.setState({
            isLoading: true
        });

        this.userService.getFilteredUsers(from, numberOfRows, this.state.searchText.trim()).then(
            (data: UserGridModel) => {
                this.setState({
                    isLoading: false,
                    from: from,
                    users: data.users,
                    totalRecordsCount: data.totalRecordsCount,
                    numberOfPages: (data.totalRecordsCount % this.state.numberOfRows > 0 ?
                        data.totalRecordsCount / this.state.numberOfRows + 1 : data.totalRecordsCount / this.state.numberOfRows)
                });
            })
            .catch(error => {
                this.growl.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }


    paginataorClick = (page) => {
        this.setState({ page: page }, () => this.getAllFilteredItems(page, this.state.numberOfRows));
    }

    handleSelectionChange = (e) => {
        this.setState({
            selectedUser: e
        });
    }

    handleSearchChange = (value: string) => {
        this.setState({ searchText: value.trim() });
    }

    public render() {

        const { isLoading, currentUser, relationType, userTypes, searchText, users, selectedUser, numberOfPages, page } = this.state;

        return (
            <>
                <Dialog
                    open={this.props.isVisible}
                    onClose={this.handleCancelButton}
                    fullWidth
                >
                    <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{this.props.dialogHeader}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        <div>
                            {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
                            {isLoading ? <Spinner /> : null}
                            <Growl ref={(el) => this.growl = el} />
                            <div className="p-g p-fluid">
                                {!currentUser.userId || currentUser.userId <= 0 ?
                                    <div className="p-col-12 p-md-12">
                                        <FormControl>
                                            <InputLabel htmlFor="user-type-label">{Translate('Select')}</InputLabel>
                                            <Select
                                                value={currentUser.userTypeId ? currentUser.userTypeId : ''}
                                                onChange={(e) => this.handleChange('userTypeId', e.target.value)}
                                                inputProps={{
                                                    id: 'user-type-label'
                                                }}
                                            >
                                                {
                                                    userTypes.map(m => <MenuItem key={m.value + 'userType'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </div>
                                    : null}
                                {currentUser.userTypeId == UserType.UserCreated ?
                                    <div className="p-g-12 p-md-12 pt-0">
                                        <TextField
                                            autoComplete="off"
                                            name="name"
                                            label={Translate('Name')}
                                            required
                                            value={currentUser && currentUser.name ? currentUser.name : ""}
                                            onChange={(e) => this.handleChange('name', e.target['value'])}
                                        />
                                    </div>
                                    : null}
                                <div className="p-col-12 p-md-12">
                                    <FormControl>
                                        <InputLabel htmlFor="relatiom-label">{Translate('RelationType') + "*"}</InputLabel>
                                        <Select
                                            value={currentUser.relationType ? currentUser.relationType : ''}
                                            onChange={(e) => this.handleChange('relationType', e.target.value)}
                                            inputProps={{
                                                id: 'relation-label'
                                            }}
                                        >
                                            {
                                                relationType.map(m => <MenuItem key={m.value + 'relation'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                                            }
                                        </Select>
                                    </FormControl>
                                </div>
                                {currentUser.userTypeId == UserType.UserCreated ?
                                    <div className="p-g-12 p-md-12">
                                        <TextField
                                            autoComplete="off"
                                            name="email"
                                            label={Translate('Email')}
                                            type="email"
                                            value={currentUser && currentUser.email ? currentUser.email : ""}
                                            onChange={(e) => this.handleChange('email', e.target['value'])}
                                        />
                                    </div>
                                    :
                                    <>
                                        <div className="user-condition-filter" style={{ padding: '0.5em', marginTop: '10px' }}>
                                            <Paper style={Constants.inputWithButton.root} elevation={1}>
                                                <InputBase style={Constants.inputWithButton.input} placeholder={Translate('SearchUserInDatabase')}
                                                    onChange={(e) => this.handleSearchChange(e.target['value'])}
                                                    onKeyPress={this.handleKeyPress}
                                                    value={searchText ? searchText : ""}
                                                    inputProps={{
                                                        id: "name-email-label"
                                                    }}
                                                />
                                                <IconButton
                                                    color="primary"
                                                    style={Constants.inputWithButton.iconButton}
                                                    onClick={this.handleSearchButtonClick}
                                                >
                                                    <SearchIcon />
                                                </IconButton>
                                            </Paper>
                                        </div>
                                        <div>
                                            <ul className="list-items" style={{ minHeight: '100px', maxHeight: '400px' }}>
                                                {users && users.length > 0 ?
                                                    users.map((m: UserForGridModel) =>
                                                        <li key={m.userId + 'uListId'} onClick={() => this.handleSelectionChange(m)}>
                                                            <div className="item-actions">
                                                                <Radio
                                                                    checked={selectedUser.userId == m.userId}
                                                                    onChange={e => this.handleSelectionChange(m)}
                                                                    color="primary"
                                                                />
                                                            </div>
                                                            <div className="item-info">
                                                                <div className="item-name">
                                                                    {m.name}
                                                                </div>
                                                                <div className="item-desc">
                                                                    {m.email}
                                                                </div>
                                                            </div>

                                                        </li>
                                                    ) : null}
                                            </ul>

                                            {numberOfPages > 1 ?
                                                <div style={{ marginBottom: '10px', marginTop: '10px', textAlign: "center" }}>
                                                    <Paginator numberOfPages={numberOfPages} page={page} paginataorClick={this.paginataorClick} />
                                                </div>
                                                : null}
                                        </div>
                                    </>}
                            </div>
                        </div>
                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div>
                            <Button variant="contained" size="small" onClick={this.handleCancelButton} style={{ marginRight: '10px' }}>
                                <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                                {Translate('Cancel')}
                            </Button>
                            {currentUser.userTypeId == UserType.UserCreated ?
                                <Button variant="contained" size="small" color="primary" onClick={(e) => this.handleSaveButton(e, true)}
                                    disabled={!currentUser || !currentUser.name || currentUser.name.trim() == '' || !currentUser.relationType}>
                                    <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                                    {Translate('Save')}
                                </Button>
                                :
                                <Button variant="contained" size="small" color="primary" onClick={(e) => this.handleCaretakerSaveButton(e, true)}
                                    disabled={!selectedUser || !currentUser.relationType || !selectedUser.userId}>
                                    <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                                    {Translate('Save')}
                                </Button>}
                        </div>
                    </Modal.DialogActions>
                </Dialog>
            </>
        )
    }
}

export default UserFamilyAddEditDialog;